// Composables
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    { path: '/',
        component: () => import('@/components/Main'),
        name: 'Main',
        children: [
            { path: '',
                component: () => import('@/components/main/RequestForm.vue'),
                name: 'RequestForm',
            },
            { path: 'bestaetigung',
                component: () => import('@/components/main/RequestConfirmation.vue'),
                name: 'RequestConfirmation',
            },
        ],
    },
  ]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
})

export default router
